<template>
  <div class="horizontal layout center">
    <div
      class="mr-0 count-answer"
      v-if="countVoteMultipleChoiceVisible"
      v-tooltip="tooltipCountVoteMultipleChoice"
    >
      <i class="fas fa-hand-paper fa-fw" aria-hidden="true" />
      <span
        class="count-answer-number"
      >{{ (slideActive.multipleCountAnswer || 0) | formatTotalPoint }}
      </span>
    </div>
    <div
      class="mr-0 count-answer"
      v-tooltip="tooltipCountAnswerWordCloud"
      v-if="slideActive.type == 'wordCloud'"
    >
      <i class="fas fa-hand-paper fa-fw" aria-hidden="true" />

      <span
        v-if="!slideActive.hideResult"
        class="count-answer-number"
      >{{ (slideActive.SlideOptions.length || 0) | formatTotalPoint }}</span>
      <span v-if="slideActive.hideResult">0</span>
    </div>
    <div
      class="mr-0 count-answer"
      v-tooltip="tooltipCountAnswerOpenEnded"
      v-if="slideActive.type === 'openEnded'"
    >
      <i class="fas fa-hand-paper fa-fw" aria-hidden="true" />

      <span
        v-if="!slideActive.hideResult"
        class="count-answer-number"
      >{{ (slideActive.openededCount || 0) | formatTotalPoint }}</span>
      <span v-if="slideActive.hideResult">0</span>
    </div>
    <div
      class="mr-0 count-answer"
      v-tooltip="tooltipCountIdeas"
      v-if="slideActive.type === 'ideas'"
    >
      <i class="fas fa-hand-paper fa-fw" aria-hidden="true" />

      <span
        class="count-answer-number"
      >{{ (slideActive.SlideOptions.length || 0) | formatTotalPoint }}</span>
    </div>
    <div
      class="mr-0 count-answer count-answer-question"
      v-tooltip="tooltipCountQuestionQnA"
      v-if="
        slideActive.type != 'pickAnswer' &&
          slideActive.type != 'leaderboard' &&
          (slideActive.type == 'question' ||
            presentation.qnaAllSlide == 'true' ||
            presentation.qnaAllSlide === true)
      "
      @click="showingQnASession()"
    >
      <span
        :class="{ 'animate__bounceIn animate__animated': questionAnimate }"
        class="count-question-animate"
      >
        <i class="fas fa-question-circle" />
        <div class="arrow-right-triangle" />
      </span>
      <span class="count-question-number">
        {{ ($store.state.questionCount || 0) | formatTotalPoint }}</span>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import EventBus from '@/eventBus'

export default {
  data() {
    return {
      questionAnimate: false,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
    countVoteMultipleChoiceVisible() {
      const { type } = this.slideActive
      return type === 'scale' ||
        type === 'multipleChoice' ||
        type === 'pickAnswer' ||
        type === 'imageChoice'
    },
    tooltipCountAnswerOpenEnded() {
      if (this.slideActive.openededCount > 1) {
        return `${this.slideActive.openededCount} ${this.$i18nPresenter.t('answers')}`
      }
      return `${this.slideActive.openededCount} ${this.$i18nPresenter.t('answers')}`
    },
    tooltipCountAnswerWordCloud() {
      if (this.slideActive.SlideOptions.length > 1) {
        return `${this.slideActive.SlideOptions.length} ${this.$i18nPresenter.t('answers')}`
      }
      return `${this.slideActive.SlideOptions.length} ${this.$i18nPresenter.t('answers')}`
    },
    tooltipCountQuestionQnA() {
      if (!this.$store.state.questionCount || this.$store.state.questionCount < 2) {
        return `${this.$store.state.questionCount} ${this.$i18nPresenter.t('unanswered question')}`
      }
      return `${this.$store.state.questionCount} ${this.$i18nPresenter.t('unanswered questions')}`
    },
    tooltipCountVoteMultipleChoice() {
      if (!this.slideActive.multipleCountAnswer) {
        return `0 ${this.$i18nPresenter.t('voter')}`
      }
      if (this.slideActive.multipleCountAnswer > 1) {
        return `${this.slideActive.multipleCountAnswer} ${this.$i18nPresenter.t('voter')}`
      }
      return `${this.slideActive.multipleCountAnswer} ${this.$i18nPresenter.t('voter')}`
    },
    tooltipCountIdeas() {
      if (!this.slideActive.SlideOptions.length) {
        return `0 ${this.$i18nPresenter.t('idea')}`
      }
      if (this.slideActive.SlideOptions.length > 1) {
        return `${this.slideActive.SlideOptions.length} ${this.$i18nPresenter.t('idea')}`
      }
      return `${this.slideActive.SlideOptions.length} ${this.$i18nPresenter.t('idea')}`
    },
  },
  mounted() {
    const self = this
    EventBus.$on('questionAnimationAction', () => {
      if (!self.questionAnimate) {
        self.questionAnimate = true
        setTimeout(() => {
          self.questionAnimate = false
        }, 2000)
      }
    })
  },
  destroyed() {
    EventBus.$off('questionAnimationAction')
  },
  methods: {
    showingQnASession() {
      if (this.slideActive.type === 'question') return
      this.$store.state.showQnaSession = true
    },
  },
}
</script>
